import {Col, Form, Input, InputNumber, Row} from "antd";
import React, {useEffect} from "react";


const Content = ({id, form}) => {

    useEffect(() => {
    }, [])


    return (
        <>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Mã phiếu "}
                        name="maPhieu"
                    >
                        <Input disabled={true}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Khách hàng "}
                        name="khachHang"
                    >
                        <Input disabled={true}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Biển số xe "}
                        name="soXe"
                    >
                        <Input disabled={true}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Tên hàng "}
                        name="tenHang"
                    >
                        <Input disabled={true}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Đơn giá "}
                        name="donGia"
                    >
                        <InputNumber placeholder={"Nhập đơn giá"}
                                     formatter={(
                                         value
                                     ) =>
                                         `${value}`.replace(
                                             /\B(?=(\d{3})+(?!\d))/g,
                                             ","
                                         )
                                     }
                                     parser={(
                                         value
                                     ) =>
                                         value.replace(
                                             /\$\s?|(,*)/g,
                                             ""
                                         )
                                     }
                                     controls={
                                         false
                                     } style={{ width: "100%" }}/>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={12}>
                <Col
                    xxl={{span: 24}}
                    xl={{span: 24}}
                    lg={{span: 24}}
                >
                    <Form.Item
                        label={"Phí vận chuyển "}
                        name="shipFee"
                    >
                        <InputNumber placeholder={"Nhập phí vận chuyển"}
                                     formatter={(
                                         value
                                     ) =>
                                         `${value}`.replace(
                                             /\B(?=(\d{3})+(?!\d))/g,
                                             ","
                                         )
                                     }
                                     parser={(
                                         value
                                     ) =>
                                         value.replace(
                                             /\$\s?|(,*)/g,
                                             ""
                                         )
                                     }
                                     controls={
                                         false
                                     } style={{ width: "100%" }}/>
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default Content
